var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar-container"},[_c('div',{staticClass:"tabbar-item"},[_c('base-icon',{staticClass:"icon",attrs:{"name":"home"}}),_c('span',{staticClass:"tit"},[_vm._v("首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }